/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} System_Status_Admin_TagInputs */



/**
* | output |
* | --- |
* | "Admin" |
*
* @param {System_Status_Admin_TagInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const system_status_admin_tag = /** @type {((inputs?: System_Status_Admin_TagInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<System_Status_Admin_TagInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Admin")
	return /** @type {LocalizedString} */ ("Admin")
});